import type { Interceptor } from "@connectrpc/connect";

/**
 * caseTokenInterceptor は URL 由来の案件アクセストークンを `x-case-token` ヘッダに付与する
 * Connect Interceptor (ADR-011)。ゲストアプリは Cognito を通さず、このトークンのみが
 * backend の Guest 公開 Interceptor に対する認可の根拠となる。
 * トークン未設定 (例: 案件トップ以外の初期表示直後) はヘッダを付与しない。
 */
export function caseTokenInterceptor(getCaseToken: () => string | undefined): Interceptor {
  return (next) => async (req) => {
    const caseToken = getCaseToken();
    if (caseToken) {
      req.header.set("x-case-token", caseToken);
    }
    return next(req);
  };
}

/**
 * reservationTokenInterceptor は URL 由来の予約アクセストークンを `x-reservation-token` ヘッダに
 * 付与する Connect Interceptor (§6.5)。予約完了画面の GetReservation はこのトークンで認可される。
 * トークン未設定 (予約系画面以外) はヘッダを付与しない。
 */
export function reservationTokenInterceptor(
  getReservationToken: () => string | undefined,
): Interceptor {
  return (next) => async (req) => {
    const reservationToken = getReservationToken();
    if (reservationToken) {
      req.header.set("x-reservation-token", reservationToken);
    }
    return next(req);
  };
}

/**
 * npsTokenInterceptor は URL 由来の NPS アンケートトークンを `x-nps-token` ヘッダに付与する
 * Connect Interceptor (§6.7)。case-token / reservation-token と並ぶ 3 系統目のトークンで、
 * GetNPSContext / SubmitNPSAnswer はこのトークンで認可される。
 * トークン未設定 (アンケート画面以外) はヘッダを付与しない。
 */
export function npsTokenInterceptor(getNPSToken: () => string | undefined): Interceptor {
  return (next) => async (req) => {
    const npsToken = getNPSToken();
    if (npsToken) {
      req.header.set("x-nps-token", npsToken);
    }
    return next(req);
  };
}
